const toTimelineDate = (dayKey) => (/^\d{4}-\d{2}-\d{2}$/.test(String(dayKey || ''))
  ? `${dayKey}T12:00:00`
  : null);

export const buildMedicationTimelineNavigationState = ({
  childId,
  occurrenceIds,
  scheduledDayKey,
  timelineEntryId = '',
  updated = false,
}) => {
  const sortedIds = [...occurrenceIds].filter(Boolean).sort();
  const isRound = sortedIds.length > 1;

  return {
    selectedChildId: childId,
    timelineChildId: childId,
    childShellTarget: 'today',
    selectedDate: toTimelineDate(scheduledDayKey),
    timelineEntryId: timelineEntryId || (isRound ? `medround_${sortedIds[0]}` : `medadmin_${sortedIds[0]}`),
    timelineToastMessage: updated ? 'Medication record updated' : 'Medication recorded',
  };
};
